import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { CompaniesService } from 'src/app/services/yardscore-services/companies.service';
@Component({
  selector: 'app-edit-company-user',
  templateUrl: './edit-company-user.component.html',
  styleUrls: ['./edit-company-user.component.css']
})
export class EditCompanyUserComponent implements OnInit {
  companyId: number;
  errors: any = {};  
  userId: number;
  userForm: FormGroup;
  isSubmitting = false;
  permissionsList = [
    'Light Calculator',
    'Gaia Project',
    'Shipping',
    'Components management',
    'Manage users'
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private companiesService: CompaniesService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.userForm = this.fb.group({
      fullName: [''],
      email: [''],
      phoneNumber: [''],
      department: [''],
      role: [''],
      permission: [''],
      permissionDate: [''],
      access: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.companyId = +this.route.snapshot.paramMap.get('companyId')!;
    this.userId = +this.route.snapshot.paramMap.get('userId')!;
    this.loadUser();
  }

  get accessFormArray() {
    return this.userForm.get('access') as FormArray;
  }

  loadUser(): void {
    this.companiesService.getUserById(this.userId).subscribe((user) => {
      this.userForm.patchValue(user);
      user.access.forEach((access: string) => {
        this.accessFormArray.push(this.fb.control(access));
      });
    });
  }

  onPermissionChange(event: any) {
    const value = event.target.value;
    const checked = event.target.checked;
    const accessArray = this.accessFormArray;

    if (checked) {
      accessArray.push(this.fb.control(value));
    } else {
      const index = accessArray.controls.findIndex(x => x.value === value);
      if (index >= 0) {
        accessArray.removeAt(index);
      }
    }
  }

  updateUser(): void {
    if (this.isSubmitting) return;
  
    this.isSubmitting = true;
    const data = this.userForm.value;
  
    if (!data.permissionDate) {
      const today = new Date().toISOString().split('T')[0]; 
      data.permissionDate = today;
      this.userForm.patchValue({ permissionDate: today }); 
    }
  
    this.companiesService.updateCompanyUser(this.userId, data).pipe(
      catchError(error => {
        this.errors = {};
  
        if (error.status === 400 && Array.isArray(error.error)) {
          error.error.forEach((msg: string) => {
            if (msg.toLowerCase().includes('full name')) {
              this.errors.fullName = [...(this.errors.fullName || []), msg];
            } else if (msg.toLowerCase().includes('email')) {
              this.errors.email = [...(this.errors.email || []), msg];
            } else if (msg.toLowerCase().includes('phone')) {
              this.errors.phoneNumber = [...(this.errors.phoneNumber || []), msg];
            } else if (msg.toLowerCase().includes('role')) {
              this.errors.role = [...(this.errors.role || []), msg];
            } else {
              this.errors.general = [...(this.errors.general || []), msg];
            }
          });
        } else {
          this.toastr.error("An unexpected error occurred.");
        }
  
        return [];
      })
    ).subscribe(() => {
      this.toastr.success("User updated successfully!");
      this.router.navigate([`/homeAdmin/v2/companies/${this.companyId}/users`]);
    }).add(() => {
      this.isSubmitting = false;
    });
  }
  
}
